export enum ActionCode {
  wlToWl = 'WLToWL',
  restartWL = 'restartWL',
  wlToWs = 'WLToWS',
  wsToWl = 'WSToWL',
  wsToWs = 'WSToWS',
  ws2ToWl = 'WS2ToWL',
  ws2ToWs = 'WS2ToWS',
}
